import React from "react";
import { ClockIcon } from "lucide-react";
import { useLoopingCountdown } from "../hooks/useLoopingCountdown";
type CountdownProps = {
  tone?: "dark" | "light";
  label?: string;
};
export function Countdown({
  tone = "light",
  label = "Promotional price ends in:"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const dark = tone === "dark";
  return <div className="w-full" role="timer" aria-label={`${label} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`} data-id="element-21" data-mp="3h1qttudueqhj">
      <p className={`mb-3 flex items-center justify-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em] ${dark ? "text-gold" : "text-danger"}`} data-id="element-22" data-mp="325j7ooivjezm">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="10cv062z765e1" />
        {label}
      </p>
      <div className="flex items-start justify-center gap-2 sm:gap-3" data-id="element-24" data-mp="15a4zqbgavxfl">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-25" data-mp="xzlpzjbueksb" data-mpi={i}>
            {i > 0 && <span className={`pt-2.5 text-2xl font-extrabold ${dark ? "text-white/60" : "text-ink/40"}`} aria-hidden="true" data-id="element-26" data-mp="t2vaax3y9r7f">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-27" data-mp="12s55ilu3bpzr">
              <span className={`min-w-[68px] rounded-xl px-3 py-2.5 text-center text-3xl font-black tabular-nums sm:min-w-[80px] sm:text-4xl ${dark ? "bg-white text-navy-900" : "bg-navy-900 text-white"}`} data-id="element-28" data-mp="12solvy43e6bo">
                {pad(unit.value)}
              </span>
              <span className={`mt-1.5 text-[11px] font-bold uppercase tracking-wider ${dark ? "text-white/70" : "text-ink-muted"}`} data-id="element-29" data-mp="k1ezio983n2o">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}
function pad(n: number): string {
  return n.toString().padStart(2, "0");
}